import { useState, useEffect } from "react";

const TextToSpeech = () => {
  const [isPaused, setIsPaused] = useState(false);
  const [utterance, setUtterance] = useState(null);
  const [voice, setVoice] = useState(null);
  const [pitch, setPitch] = useState(1);
  const [rate, setRate] = useState(1);
  const [volume, setVolume] = useState(1);
  const [txt,  setTxt] = useState("Hello Freelance in Thailand.");


  useEffect(() => {
    const synth = window.speechSynthesis;
    const u = new SpeechSynthesisUtterance(txt);
    const voices = synth.getVoices();

    setUtterance(u);
    setVoice(voices[0]);

    return () => {
      synth.cancel();
    };
  }, [txt]);

  const handleTxtChange = (e) => {
    setTxt(e.target.value)

    }


  const handlePlay = () => {
    const synth = window.speechSynthesis;

    if (isPaused) {
      synth.resume();
    } else {
      utterance.voice = voice;
      utterance.pitch = pitch;
      utterance.rate = rate;
      utterance.volume = volume;
      synth.speak(utterance);
    }

    setIsPaused(false);
  };

  const handlePause = () => {
    const synth = window.speechSynthesis;

    synth.pause();

    setIsPaused(true);
  };

  const handleStop = () => {
    const synth = window.speechSynthesis;

    synth.cancel();

    setIsPaused(false);
  };

  const handleVoiceChange = (event) => {
    const voices = window.speechSynthesis.getVoices();
    setVoice(voices.find((v) => v.name === event.target.value));
  };

  const handlePitchChange = (event) => {
    setPitch(parseFloat(event.target.value));
  };

  const handleRateChange = (event) => {
    setRate(parseFloat(event.target.value));
  };

  const handleVolumeChange = (event) => {
    setVolume(parseFloat(event.target.value));
  };

  return (
    <div className="flex flex-col p-4 items-center justify-center">
        <h1>Text To Speech</h1>
        <label>
            Voice:
            <select 
                value={voice?.name} 
                onChange={handleVoiceChange} 
                className="text-black text-sm rounded-md border">
                    {window.speechSynthesis.getVoices().map((voice) => (
                         <option key={voice.name} value={voice.name}>
                            {voice.name}
                        </option>
                    ))}
            </select>
        </label>

        <div className="p-2">
            <label>
                Pitch:
                <input
                    type="range"
                    min="0.5"
                    max="2"
                    step="0.1"
                    value={pitch}
                    onChange={handlePitchChange}
                    className="accent-pink-500"
                />
            </label>
        </div>
        <div className="p-2">
            <label>
                Speed:
                <input
                    type="range"
                    min="0.5"
                    max="2"
                    step="0.1"
                    value={rate}
                    onChange={handleRateChange}
                />
            </label>
        </div>
        <div className="p-2">
            <label>
                Volume:
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.1"
                    value={volume}
                    onChange={handleVolumeChange}
                    className="accent-lime-500"
                />
            </label>
        </div>
        <div className="flex p-2 px-4 gap-x-4">

            <button 
                onClick={handlePlay}
                className="rounded-xl p-2 bg-violet-500 hover:bg-violet-600 active:bg-violet-700 focus:outline-none focus:ring focus:ring-violet-300"
            >
                    {isPaused ? "Resume" : "Play"}
            </button>
            <button 
                onClick={handlePause}
                className="rounded-xl p-2 bg-slate-500 hover:bg-slate-600 active:bg-slate-700 focus:outline-none focus:ring focus:ring-slate-300"
            >
                    Pause
                </button>
            <button 
                onClick={handleStop}
                className="rounded-xl p-2 bg-red-500 hover:bg-red-600 active:bg-red-700 focus:outline-none focus:ring focus:ring-red-300"
            >
                    Stop
            </button>
        </div>
        <textarea
            name="text"
            value={txt}
            rows={4}
            cols={40}
            onChange={handleTxtChange}
            className="justify-center indent-8 text-black text-sm p-2 resize border rounded-xl focus:outline-none ring-inset focus:ring focus:border-blue-500" 
        />
    </div>
  );
};

export default TextToSpeech;